import { Component } from '@angular/core';
import { getSegmentName, translateSegments } from '@shared-libs/helpers';
import { Segment } from '@beego/ngx-segment';
import { MessageBoxKey } from '@shared-libs/enums';

@Component({
	selector: 'administration-desktop-page',
	templateUrl: 'administration.desktop.page.html',
	styleUrls: ['./administration.desktop.page.scss'],
})
export class AdministrationDesktopPage {
	public readonly segments: Array<Segment> = translateSegments([
		'LOCATIONS',
		'EVENT_TYPES',
		'DEVICE_TYPES',
		'CLIENT_ORIGINS',
		'QUESTION_CATEGORIES',
		'DIGIBANK_AGENCY',
		'TARGET_AUDIENCE',
		'CANCELLATION_REASON',
	]);
	public readonly MessageBoxKey = MessageBoxKey;
	public selectedSegment: string = getSegmentName(this.segments[0]);
	public getSegmentName = getSegmentName;
	public onSelectedSegmentChange(segment: string): void {
		this.selectedSegment = segment;
	}
}
